// ── Cerrar sesión (2026-10-06) ───────────────────────────────────────────────
// La ruta POST /api/auth/logout existía desde la Fase 0 y el texto "Cerrar
// sesión" también, pero ninguna pantalla los usaba: no había forma de salir.
// El botón vive en el pie (AppFooter), a la derecha de la ayuda.
//
// Sale con una recarga completa y no navegando: la caché de datos, el
// asistente y el modo de voz viven en memoria, y no tienen que sobrevivirle a
// la sesión — en una computadora compartida, el siguiente vería lo del
// anterior hasta recargar.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../components/ui/Toast.js';
import { api, ApiError } from '../lib/api.js';

export function useCerrarSesion(): { cerrar: () => void; saliendo: boolean } {
  const { t } = useTranslation();
  const toast = useToast();
  const [saliendo, setSaliendo] = useState(false);

  async function cerrarAsync() {
    setSaliendo(true);
    try {
      await api.post('/api/auth/logout');
    } catch (err) {
      // 401 = la sesión ya no valía: igual hay que mostrar el login. Cualquier
      // otro error (red caída) dejaría la sesión viva en el servidor, y salir
      // de la pantalla haría creer que se cerró.
      if (!(err instanceof ApiError && err.status === 401)) {
        setSaliendo(false);
        toast.error(t('auth.logoutError'));
        return;
      }
    }
    window.location.assign('/');
  }

  return { cerrar: () => { void cerrarAsync(); }, saliendo };
}
